import router from "../router";
import CryptoJS from "crypto-js";
export function toFixed(val, length = 2) {
	//不是数字，返回-
	if (isNaN(parseFloat(val))) {
		return "-";
	}
	if (val === 0) return 0;
	if (["number", "string"].includes(typeof val)) {
		if (val == 0) return 0;
		if (String(val).match(/\./) || String(val).includes("e-")) {
			let newVal = parseFloat(Number(val).toFixed(length));
			if (newVal === 0) return 0; //转换后有可能是 -0
			return newVal;
		} else {
			return val;
		}
	}
	return "-";
}

export const map = {
	sharp: "尖",
	peak: "峰",
	flat: "平",
	valley: "谷",
	ravine: "深谷",
};

/**
 *	无数据占位图
 */
const emptyImage =
	"data:image/svg+xml;base64,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";

export function setNotOpt(subtext = "暂无数据") {
	var option = {
		title: {
			text: " {a|}",
			x: "center",
			y: "center",
			subtext,
			itemGap: 0,
			textStyle: {
				rich: {
					a: {
						color: "#a7a7a7",
						height: 30,
						width: 30,
						backgroundColor: {
							image: emptyImage,
						},
					},
				},
			},
			subtextStyle: {
				fontSize: 14,
				color: "#a7a7a7",
			},
		},
	};
	return option;
}

export const defaultOptions = {
	xAxis: {
		type: "category",
		axisTick: {
			show: false,
		},
		data: [],
	},
	yAxis: {
		type: "value",
		nameTextStyle: {
			color: "rgba(0,0,0,0.8)",
			fontSize: 12,
			padding: [0, 0, 5, -20],
		},
		splitLine: {
			show: true, // 显示 Y 轴虚线
			lineStyle: {
				type: "dashed", // 设置虚线样式
				color: "#A2ABBB", // 设置虚线的颜色
			},
		},
	},
	grid: {
		left: "2%",
		right: "2%",
		top: "13%",
		bottom: "0%",
		containLabel: true,
	},
	legend: {
		top: "0%",
		right: "0%",
		textStyle: {
			color: "rgba(0,0,0,0.8)",
		},
		icon: "roundRect",
		itemWidth: 12,
		itemHeight: 4,
	},
	tooltip: {
		trigger: "axis",
	},
	// dataZoom: [
	// 	{
	// 		type: "inside"
	// 	}
	// ],
	series: [],
};

// 处理策略数据
export const handleTacticsData = (curve = [], range = []) => {
	console.log("@@@");
	console.log(curve, range);
	let x_data = [];
	let y_data = [];
	curve.map(el => {
		let time = el.time.split(":").splice(0, 2).join(":");
		x_data.push(time);
		y_data.push(toFixed(el.value));
	});
	let allTimes = [...x_data];
	let markAreaData = [];

	range.map(el => {
		allTimes.push(el.start);
		allTimes.push(el.end);
		markAreaData.push([
			{
				name: map[el.type],
				xAxis: el.start,
				itemStyle: {
					color:
						el.type == "sharp"
							? "rgba(197,202,213,0.6)"
							: el.type == "peak"
							? "rgba(197,202,213,0.5)"
							: el.type == "flat"
							? "rgba(197,202,213,0.4)"
							: el.type == "valley"
							? "rgba(197,202,213,0.3)"
							: "rgba(197,202,213,0.2)",
				},
			},
			{
				xAxis: el.end,
			},
		]);
	});

	let Options = {
		...JSON.parse(JSON.stringify(defaultOptions)),
		series: [
			{
				name: "电价",
				data: y_data,
				type: "line",
				symbol: "none", // 去除圆点
			},
			{
				name: "scatter",
				type: "scatter",
				markArea: {
					data: markAreaData,
				},
			},
		],
	};
	Options.grid = {
		left: "2%",
		right: "5%",
		top: "13%",
		bottom: "0%",
		containLabel: true,
	};
	Options.xAxis.data = [...new Set(allTimes)].sort();
	Options.yAxis.interval = 1; // 设置刻度线的显示间隔为 1
	return Options;
};

// 点击跳转官网
export const goCompanyHome = () => {
	window.open("https://www.skiffenergy.com/", "_blank");
};

// 定义加密字符串
const secretKey = "skiffenergy";

// crypto-js加密
export const encryptData = data => {
	const encryptedData = CryptoJS.AES.encrypt(
		String(data),
		secretKey
	).toString();
	return encryptedData;
};

// crypto-js解密
export const decryptData = encryptedData => {
	const decryptedData = CryptoJS.AES.decrypt(
		encryptedData,
		secretKey
	).toString(CryptoJS.enc.Utf8);
	return decryptedData;
};
